import { render, staticRenderFns } from "./PartyFields.vue?vue&type=template&id=a940567a"
import script from "./PartyFields.vue?vue&type=script&lang=js"
export * from "./PartyFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports